function popup(data, closeButton, button) {
    let scrollPosition;
    const ua = window.navigator.userAgent.toLowerCase();
    const isiOS = ua.indexOf('iphone') > -1 || ua.indexOf('ipad') > -1 || ua.indexOf('macintosh') > -1 && 'ontouchend' in document;

    function bodyFixedOn() {
        if (isiOS) {
            scrollPosition = $(window).scrollTop();
            $('body').addClass('jsModalOpenedIOS');
            $('body').css('top', `-${scrollPosition}px`);
        } else {
            $('body').addClass('jsModalOpened');
        }
    }

    function bodyFixedOff() {
        if (isiOS) {
            $('body').removeClass('jsModalOpenedIOS');
            $('body').css('top', '');
            $(window).scrollTop(scrollPosition);
        } else {
            $('body').removeClass('jsModalOpened');
        }
    }

    button.magnificPopup({
        items: {
            src: data,
            type: 'inline',
        },
        settings: null,
        closeOnBgClick: true,
        mainClass: 'mfp-fade',
        removalDelay: 600,
        closeMarkup: closeButton,
        callbacks: {
            open() {
                bodyFixedOn();
            },
            close() {
                bodyFixedOff();
            },
        },
    }).magnificPopup('open');
}

$(() => {
    //
    $('.jsMagnific').click(function (e) {
        const $this = $(this);

        var closeBtnUrl = $(this).data('close-btn');
        let closeButton = 
            '<button title="Close (Esc)" type="button" class="mfp-close mfp-close--custom" onclick="$.magnificPopup.close();"><img src="'
        +   closeBtnUrl
        +   '"></button>';

        if ($this.hasClass('jsNoDispClose')) {
            closeButton = '';
        }

        $.ajax({
            url: $this.attr('href'),
            type: 'get',
            data: [],
        }).done((data) => {
            popup(data, closeButton, $this);
        }).fail((data) => {
            if (data.responseJSON.redirectUrl) {
                window.location.href = data.responseJSON.redirectUrl;
            }
        });

        e.preventDefault();
        return false;
    });
});
